import Typography from "../components/Typography";
import { UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import { CORPORATE_TYPE, INDIVIDUAL_TYPE } from "../constants";
import useIsDesktop from "../utils/hooks/useIsDesktop";
import { FormattedMessage } from "react-intl";

const RegisterType = (props) => {
  const { onChooseType } = props;

  const navigate = useNavigate();
  const isDesktop = useIsDesktop();

  const handleChooseType = (type) => {
    onChooseType(type);
  };

  const handleClickSignIn = () => {
    navigate("/login");
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        borderRadius: "8px",
        backgroundColor: "white",
        padding: "24px",
        // justifyContent: "center",
        justifyContent: "center",
        width: !isDesktop ? "350px" : "500px",
        // width: "350px",
      }}
    >
      <div className="d-flex flex-column justify-content-center w-100">
        <div className="py-5">
          <Typography fontType="heading" size="28px" lineHeight="36px">
          <FormattedMessage id='titleChoose' defaultMessage='Choose' />
          </Typography>
          <Typography fontType="heading" size="28px" lineHeight="36px">
          <FormattedMessage id='titleRegistrationType' defaultMessage='Registration Type' />
          </Typography>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            borderRadius: "8px",
            backgroundColor: "white",
            padding: "8px 16px",
            border: "1px solid lightgray",
            alignItems: "center",
            height: "60px",
            width: "100%",
            cursor: 'pointer'
          }}
          onClick={() => handleChooseType(INDIVIDUAL_TYPE)}
        >
          <UserOutlined />
          <Typography className="pl-3" isBold>
          <FormattedMessage id='btnIndividual' defaultMessage='Individual' />
          </Typography>
        </div>
        <div
          className="mt-3"
          style={{
            display: "flex",
            flexDirection: "row",
            borderRadius: "8px",
            backgroundColor: "white",
            padding: "8px 16px",
            border: "1px solid lightgray",
            alignItems: "center",
            height: "60px",
            cursor: 'pointer'
          }}
          onClick={() => handleChooseType(CORPORATE_TYPE)}
        >
          <UserOutlined />
          <Typography className="pl-3" isBold>
          <FormattedMessage id='btnCorporate' defaultMessage='Corporate' />
          </Typography>
        </div>
        <Typography className="pt-5" onClick={handleClickSignIn}>
        <FormattedMessage id='labelAlreadySignIn' defaultMessage='Already have account?' /> <a href="/login"><FormattedMessage id='btnSignIn' defaultMessage='Sign In' /></a>
        </Typography>
      </div>
    </div>
  );
};

export default RegisterType;
